// extracted by mini-css-extract-plugin
export default {"certificate":"certificate_certificate__oefoZ"};